export const MAX_RESUME_BYTES = 5 * 1024 * 1024;
export const MAX_RESUME_BASE64 = 4 * Math.ceil(MAX_RESUME_BYTES / 3);
